import React from 'react'
import Pt from 'prop-types'
import Mpt from 'react-moment-proptypes'
import { Col, FormControl, Row } from 'react-bootstrap'
import moment from 'moment'
import range from 'lodash/range'

import { FormField } from 'internal-components/src/components/Form'

export default class AppointmentDateTimeField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      date: props.date ? props.date.format('YYYY-MM-DD') : '',
      time: props.time,
    };
  }

  render() {
    const now = moment();
    const dow = now.isoWeekday(); // Mon = 1; Sun = 7
    const plusTwoWorkingDays = {
      1: 2, // Mon -> Wed
      2: 2, // Tue -> Thu
      3: 2, // Wed -> Fri
      4: 4, // Thu -> Mon
      5: 4, // Fri -> Tue
      6: 3, // Sat -> Tue
      7: 2  // Sun -> Tue
    };
    const date = this.props.date ? this.props.date.format('YYYY-MM-DD') : '';
    const time = this.props.time || '';
    const startDate = now.add(plusTwoWorkingDays[dow], 'days');
    const numDays = 28;

    const timeOptions = [
      '8 AM to 12 PM',
      '1 PM to 5 PM',
    ];

    if (time && !timeOptions.includes(time)) {
      timeOptions.push(time);
    }

    return <div>
      <Row className="appointment-date">
        <Col md={6}>
          <FormField
            bsSize="large"
            controlLabel="Preferred Installation Date"
            data-controlId="appointment-date"
            errorKey="preferredAppointmentDate"
            errors={this.props.errors}
          >
            <FormControl
              componentClass="select"
              id="appointment-date"
              onChange={e => this.props.onDateChange(e.target.value === '' ? null : moment(e.target.value))}
              value={date}
            >
              <option value="">- Select Date -</option>
              {range(0, numDays).map(day => {
                const date = startDate.clone().add(day, 'days');
                const dow = parseFloat(date.format('d'));
                if (dow >= 1 && dow <= 5) {
                  return <option key={day}
                                 value={date.format('YYYY-MM-DD')}>
                    {date.format('ddd, D MMM YYYY')}
                  </option>
                } else {
                  return null;
                }
              })}
            </FormControl>
          </FormField>
        </Col>
        <Col md={6}>
          <FormField
            bsSize="large"
            controlLabel="&nbsp;"
            data-controlId="appointment-time"
            errorKey="preferredAppointmentTime"
            errors={this.props.errors}
          >
            <FormControl
              componentClass="select"
              id="appointment-time"
              onChange={e => this.props.onTimeChange(e.target.value === '' ? null : e.target.value)}
              value={time}
            >
              <option value="">- Select Time -</option>
              {timeOptions.map((time, idx) => (
                <option key={idx} value={time}>{time}</option>
              ))}
            </FormControl>
          </FormField>
        </Col>
      </Row>
      <p>Please be advised this is your preferred appointment date, not the confirmed installation date. We will get in touch once the installation date is confirmed.</p>
    </div>;
  }
}

AppointmentDateTimeField.propTypes = {
  initialDate: Mpt.momentObj,
  initialTime: Pt.string,
  onDateChange: Pt.func.isRequired,
  onTimeChange: Pt.func.isRequired,
  errors: Pt.any,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/AppointmentDateTimeField.jsx